import React from 'react';

const FacebookIcon = props => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M18.3816 9.98833C18.3814 8.38613 17.922 6.81755 17.058 5.46828C16.194 4.11902 14.9614 3.04558 13.5063 2.37504C12.0512 1.7045 10.4344 1.46495 8.84731 1.68474C7.26026 1.90453 5.76941 2.57445 4.55126 3.61521C3.33312 4.65597 2.43869 6.02397 1.97387 7.55727C1.50905 9.09056 1.49329 10.7249 1.92848 12.2669C2.36366 13.8089 3.23155 15.1939 4.42941 16.2579C5.62727 17.322 7.10492 18.0205 8.68745 18.2708V12.4158H6.55828V9.98833H8.68745V8.14167C8.64174 7.71028 8.69143 7.27411 8.83301 6.86406C8.97459 6.45401 9.2046 6.0801 9.50674 5.76882C9.80888 5.45753 10.1758 5.21648 10.5814 5.06274C10.9871 4.909 11.4216 4.84633 11.8541 4.87917C12.4829 4.88875 13.1101 4.94445 13.7308 5.04583V7.10667H12.6741C12.494 7.08269 12.3107 7.09955 12.138 7.156C11.9652 7.21245 11.8074 7.30704 11.6761 7.43276C11.5449 7.55848 11.4436 7.71212 11.3798 7.88229C11.316 8.05246 11.2912 8.23481 11.3074 8.41583V9.98833H13.6333L13.2608 12.4158H11.3074V18.2742C13.2801 17.9616 15.0764 16.9553 16.3732 15.4364C17.67 13.9174 18.3822 11.9856 18.3816 9.98833Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FacebookIcon;
